'use client';

/* @jsxImportSource react */
import { PageMetaData } from '@packages/modules/src/PageMetaData/PageMetaData';
import { logger } from '@packages/shared/src/utils/logger/logger';
import dynamic from 'next/dynamic';
import { useIntl } from 'react-intl';
import { errorPageMessages } from './error.messages';

const DynamicErrorContent = dynamic(
  () =>
    import('@packages/modules/src/StaticErrorContent/StaticErrorContent.client').then(
      (mod) => mod.StaticErrorContent,
    ),
  {
    ssr: false,
  },
);

const CmsErrorContent = ({ error }: { error: any }) => {
  const { formatMessage } = useIntl();
  logger.error(error, 'Error in CMS Content');

  return (
    <>
      <PageMetaData page={{ type: 'error500', template: 'error500' }} />
      <DynamicErrorContent
        title={formatMessage(errorPageMessages.title)}
        description={formatMessage(errorPageMessages.description)}
        description2={formatMessage(errorPageMessages.info)}
        buttonLabel={formatMessage(errorPageMessages.buttonLabel)}
      />
    </>
  );
};

// eslint-disable-next-line import-x/no-default-export
export default CmsErrorContent;
